export const DEFAULT_QUERY = {
  expand: 'all',
};
